/* eslint-disable @typescript-eslint/no-explicit-any */
import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

const bootstrap = () => {
	return platformBrowserDynamic()
		.bootstrapModule(AppModule, {
			defaultEncapsulation: ViewEncapsulation.Emulated,
			preserveWhitespaces: false
		})
		.then(res => {
			if ((<any>window).appBootstrap) {
				(<any>window).appBootstrap();
			}
			return res;
		});
};

bootstrap().catch(console.error);
